export const I18N_LOCALES: Array<{
  key: string
  name: string
  nativeName: string
  chineseName: string
}> = [
    {
      key: 'ma',
      name: 'Malay',
      nativeName: 'Bahasa Melayu',
      chineseName: '马来语',
    },
    {
      key: 'ja',
      name: 'Japanese',
      nativeName: '日本語',
      chineseName: '日语',
    },
    {
      key: 'ko',
      name: 'Korean',
      nativeName: '한국어',
      chineseName: '韩语',
    },
    {
      key: 'fr',
      name: 'French',
      nativeName: 'Français',
      chineseName: '法语',
    },
    {
      key: 'de',
      name: 'German',
      nativeName: 'Deutsch',
      chineseName: '德语',
    },
    {
      key: 'it',
      name: 'Italian',
      nativeName: 'Italiano',
      chineseName: '意大利语',
    },
    {
      key: 'es',
      name: 'Spanish',
      nativeName: 'Español',
      chineseName: '西班牙语',
    },
    {
      key: 'ru',
      name: 'Russian',
      nativeName: 'Русский',
      chineseName: '俄语',
    },
    {
      key: 'ar',
      name: 'Arabic',
      nativeName: 'العربية',
      chineseName: '阿拉伯语',
    },
    {
      key: 'hi',
      name: 'Hindi',
      nativeName: 'हिन्दी',
      chineseName: '印地语',
    },
    {
      key: 'tr',
      name: 'Turkish',
      nativeName: 'Türkçe',
      chineseName: '土耳其语',
    },
    {
      key: 'vi',
      name: 'Vietnamese',
      nativeName: 'Tiếng Việt',
      chineseName: '越南语',
    },
    {
      key: 'id',
      name: 'Indonesian',
      nativeName: 'Indonesia',
      chineseName: '印尼语',
    },
    {
      key: 'th',
      name: 'Thai',
      nativeName: 'ไทย',
      chineseName: '泰语',
    },
  ]


